import type { FaireProductEntity } from "../../entity_types/product";

export const p_axv2b2unj4: FaireProductEntity = {
  token: "p_axv2b2unj4",
  type: "product",
  name: "Sedona Bison Skull Unisex Pocket Tee",
  brandToken: "b_fdmfz6yamg",
  brandName: "Vortex Visions Design",
  imageUrl:
    "https://cdn.faire.com/fastly/dacdf5422d32acdaeaa022b437423336e91cf8bdbc854eed5ec6a80533d9a18c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/103f269b2d608b629a17a5bed307392e6380352116967d8195aa6b41cadd1064.png",
    "https://cdn.faire.com/fastly/fe37b32e32ad0b5f24f12eed6001a6ca7a79b11772ad5217b35b3cce142827ca.png",
    "https://cdn.faire.com/fastly/8c96e75958820636ffdd6626ec28538551b52de5cd9c1469207ccd860129a993.png",
    "https://cdn.faire.com/fastly/184c102d5d81914f7a77be13f38937107d0d3123a3e524deb169a5537ae17846.png",
  ],
  priceDollars: 24.94,
  description:
    'Introducing the "Sedona Bison Skull" Pocket Tee—a unisex fit that exudes Southwestern charm and bold design. Its iconic bison skull artwork captures the rugged beauty of the Southwest. Crafted for comfort and style, this tee adapts effortlessly to any wardrobe. Whether you\'re exploring the outdoors or enjoying an urban setting, this tee offers both a bold fashion statement and lasting durability. Celebrate the untamed spirit of the American West with this distinctive and versatile pocket tee.\n\nAvailable in black, natural and pink\n\nNot located in Sedona? Customize this shirt to change the name to your retail location or city! ',
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:22.489Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
